module.exports = __webpack_public_path__ + "img/carpets-sprite-1x.cd19388d.png";